import React from 'react';
import { Link } from 'react-router-dom';
import useConfig from '../../hooks/config.hooks';
import { translate } from '../../i18n';
import { useCrumbs } from './hooks';
import './style.scss';

const Breadcrumbs: React.FC = () => {
  const crumbs = useCrumbs();
  const { ANTWERPEN_BE_URL } = useConfig();

  return (
    <nav className="ckp-o-breadcrumbs" aria-label={translate('breadcrumbs.title')}>
      <ul className="a-breadcrumb">
        <li>
          <a href={ANTWERPEN_BE_URL}>{translate('common.home')}</a>
        </li>
        {crumbs.map(({ label, href }) =>
          href ? (
            <li key={`breadcrumb-${href}`}>
              <Link to={href}>{translate(label)}</Link>
            </li>
          ) : (
            <li key={`breadcrumb-${href}`}>{translate(label)}</li>
          ),
        )}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
